import React from 'react';
import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import { PunchInputGrid } from './Styles/PunchPickerStyles';
import DateTimeInputMaskedField from './DateTimeInputMaskedField';

const FormPunchSetField = ({ punchData, handlePunchChange }) => {
  const punchInputOnChange = (value, punchInOut) => {
    const newPunchData = { ...punchData, [punchInOut]: { stamp: value } };

    handlePunchChange([newPunchData]);
  };

  return (
    <PunchInputGrid container item spacing={1}>
      <Grid item xs={6}>
        <DateTimeInputMaskedField
          label="Clock In"
          dateEpoch={punchData?.in?.stamp || punchData?.jobStart || null}
          timeEpoch={punchData?.in?.stamp || null}
          onChange={(value) => punchInputOnChange(value, 'in')}
        />
      </Grid>

      <Grid item xs={6}>
        <DateTimeInputMaskedField
          label="Clock Out"
          dateEpoch={punchData?.out?.stamp || punchData?.jobEnd || null}
          timeEpoch={punchData?.out?.stamp || null}
          onChange={(value) => punchInputOnChange(value, 'out')}
        />
      </Grid>
    </PunchInputGrid>
  );
};

FormPunchSetField.propTypes = {
  punchData: PropTypes.shape({
    in: PropTypes.shape({ stamp: PropTypes.number }),
    out: PropTypes.shape({ stamp: PropTypes.number }),
    jobStart: PropTypes.number,
    jobEnd: PropTypes.number,
  }),

  handlePunchChange: PropTypes.func,
};

export default FormPunchSetField;
